import capitalize from 'lodash/capitalize';
import moment from 'moment';

import { mString, snakeToTitleCase } from 'lib/helpers/utility';

import getCptCodes from './getCptCodes';
import getPractitionerName from './getPractitionerName';
import getServicesName from './getServicesName';

const transformAppointmentsToExportDataFormat = (events, appointmentStatuses, practitioners) => {
  return events.map((event) => {
    const { start_date, end_date, patient, status, invoice } = event;

    return {
      datetime: `${moment(start_date).format('ddd MMM D, h:mm A')} - ${moment(end_date).format(
        'h:mm A'
      )}`,
      patient_id: patient?.id || '',
      patient: patient?.fullName || '',
      event_name: event?.title ? capitalize(event?.title) : '',
      insurance_name: patient?.insurance_name || '',
      service: getServicesName(event.invoice?.procedures),
      cpt_code: getCptCodes(event.invoice?.procedures),
      provider: getPractitionerName(event, practitioners),
      balance: event.type === 'appointment' ? mString(invoice?.balance || 0) : '',
      status:
        event.type === 'appointment'
          ? appointmentStatuses.find((st) => st.value === status)?.label || snakeToTitleCase(status)
          : ''
    };
  });
};

export default transformAppointmentsToExportDataFormat;
